import { useTheme } from '@classify/react-core-components/styles';
import { useMediaQuery } from '@mui/material';

import { Breakpoint } from '../types/Breakpoint';

type ChoosableBreakpointItem<T> = {
  value: T;
  breakpoint: Breakpoint;
};

type ChoosableItem<T> = {
  value: T;
  condition: boolean;
};

function getFirstVerifiedValue<T>(items: ChoosableItem<T>[]): T | void {
  return items.find(({ condition }) => condition)?.value;
}

function useChooseValueFromBreakpoint<T>(items: ChoosableBreakpointItem<T>[]): T | void {
  const { breakpoints } = useTheme();

  const breakpointsMap: Record<Breakpoint, boolean> = {
    xs: useMediaQuery(breakpoints.up('xs')),
    sm: useMediaQuery(breakpoints.up('sm')),
    md: useMediaQuery(breakpoints.up('md')),
    lg: useMediaQuery(breakpoints.up('lg')),
    xl: useMediaQuery(breakpoints.up('xl')),
  };

  return getFirstVerifiedValue(
    items.map(({ value, breakpoint }) => ({
      value,
      condition: breakpointsMap[breakpoint],
    }))
  );
}

export default useChooseValueFromBreakpoint;
